import { PageType } from '@app-types/PageType'
import BigButton from '@components/Button/BigButton'
import SecondaryLink from '@components/Button/SecondaryLink'
import { getDuaPageAndPartKey } from '@components/DuaPage/duaPartHelper'
import { useNativeReaderLink } from '@hooks/useNativeReaderLink'
import { FaBookmark, FaHistory } from 'react-icons/fa'

type Props = {
  page: number | null
  lastReadPage?: number | null
  type: PageType
  basePath?: string
  showSmalltext?: boolean
  className?: string
  color?: 'emerald' | 'blue' | 'red' | 'gray' | 'brand'
  variant?: 'solid' | 'outline'
  children?: React.ReactNode
}

const MarkedButton: React.FC<Props> = ({
  children,
  page,
  lastReadPage,
  type,
  basePath = '',
  className = '',
  color = 'brand',
}) => {
  const getReaderLinkProps = useNativeReaderLink()
  const [bookmarkedPage, bookmarkedPart] = getDuaPageAndPartKey(page)
  const [lastReadPageKey, lastReadPart] = getDuaPageAndPartKey(lastReadPage ?? null)
  const hasBookmark = !!(page && page > 0)
  const hasLastRead = !!(lastReadPage && lastReadPage > 1)

  if (!hasBookmark && !hasLastRead) {
    return (
      <BigButton
        className={className}
        {...getReaderLinkProps(`${basePath}/${type}/1`)}
        color={color}
        variant="solid"
      >
        {children || 'Okumaya Başla'}
      </BigButton>
    )
  }

  const showTwoButtons = !!(hasBookmark && hasLastRead && page !== lastReadPage)
  const primaryPage = (hasLastRead ? lastReadPageKey : bookmarkedPage) || 1
  const primaryPart = hasLastRead ? lastReadPart : bookmarkedPart

  return (
    <div className={`flex flex-col gap-4 mx-auto w-full max-w-sm ${className}`}>
      {/* Primary Action - Resume */}
      <BigButton
        className="max-w-none! active:scale-[0.98] sacred-shadow"
        smallText={
          <div className="flex items-center justify-center gap-1.5 font-bold uppercase tracking-wider">
            {hasLastRead && showTwoButtons ? (
              <FaHistory className="w-3 h-3" />
            ) : (
              <FaBookmark className="w-3 h-3" />
            )}
            <span>
              {primaryPage}. Sayfa {primaryPart ? `| Bölüm ${primaryPart}` : ''}
            </span>
          </div>
        }
        {...getReaderLinkProps(
          `${basePath}/${type}/${primaryPage}${
            primaryPart ? `#bolum-${primaryPart}` : ''
          }`,
        )}
        color={color}
        variant="solid"
      >
        {hasLastRead && showTwoButtons
          ? 'Okumaya Devam Et'
          : children || 'İşaretlenen Yer'}
      </BigButton>

      {/* Secondary Action - Bookmark */}
      {showTwoButtons && (
        <SecondaryLink
          {...getReaderLinkProps(
            `${basePath}/${type}/${bookmarkedPage}${bookmarkedPart ? `#bolum-${bookmarkedPart}` : ''}`,
          )}
          icon={<FaBookmark className="w-4 h-4 text-brand-secondary" />}
        >
          İşaretli Sayfaya Git ({bookmarkedPage})
        </SecondaryLink>
      )}
    </div>
  )
}

export default MarkedButton
